
/**
 * Utility functions for parsing CSV files
 */

/**
 * Parse a CSV string into an array of objects
 * @param csvContent The CSV content as a string
 * @param headers Optional headers (if not provided, first row is used as headers)
 * @returns Array of objects with keys from headers and values from rows
 */
export const parseCSV = (csvContent: string, headers?: string[]): Record<string, string>[] => {
  // Split into rows and filter out empty rows
  const rows = csvContent.split('\n').filter(row => row.trim() !== '');
  
  if (rows.length === 0) {
    return [];
  }
  
  // If headers not provided, use first row
  const columnHeaders = headers || rows[0].split(',').map(header => header.trim());
  
  // Start from second row if headers were taken from first row
  const startRow = headers ? 0 : 1;
  
  // Parse each row into an object
  return rows.slice(startRow).map(row => {
    const values = row.split(',').map(value => value.trim());
    const rowData: Record<string, string> = {};
    
    // Map values to headers
    columnHeaders.forEach((header, index) => {
      rowData[header] = values[index] || '';
    });
    
    return rowData;
  });
};
